import React, { useEffect} from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions/InstallationActions";

export default function InstallationJob() {

    const dispatch = useDispatch()
    const { pathname } = useLocation();
    const trimmedPathname = pathname.slice(0, pathname.lastIndexOf('/'));
    useEffect(() => {

        dispatch(actions.VehicleListUpdate())

    }, []);

    const job = useLocation().state  
    const backButtonLink =  trimmedPathname;
    const [installers, installerJobs] = useSelector(state => state.installerList);
    const accounts = useSelector((state) => state.accountList);
    const vehicles = useSelector((state) => state.vehicleList);
    const customer = accounts.find(account => account.ID === job.CustomerID);
    const vehicle = vehicles.find(vehicle => vehicle.JobID === job.ID)

    if (!customer || !job || !vehicle) {
       
        return <div>An, error occured please refresh your page.</div>;
    }

    const installer = installers.find(installer => installer.accountID === vehicle.installerID);

   
    return (
        <div>
            <AuthenticatedTemplate>
                <div className="page-container detail-container">
                    {installer && (
                        <div className="container installer-header calendar-header job-Detail-Title-Container">
                            {backButtonLink && (


                                <Link to={backButtonLink} className="back-button-link">
                                    <button className="btn btn-secondary back-button">
                                        <span className="back-button-arrow"></span> Back
                                    </button>
                                </Link>


                            )}


                            <h1 className="job-detail-title">Installation for: {job.name || "N/A"}</h1>

                        </div>
                    )}
                    <div className="grid-container">
                        <div className="grid-item">
                            <table>
                                <thead>
                                    <tr>
                                        <th colSpan="2"><h2>Job Details</h2></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Name:</strong></td>
                                        <td>{job.name || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>ID:</strong></td>
                                        <td>{job.ID || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Installation Status:</strong></td>
                                        <td>{job.installationStatus || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Customer ID:</strong></td>
                                        <td>{job.CustomerID || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Tenant ID:</strong></td>
                                        <td>{job.TenantID || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Due Date:</strong></td>
                                        <td>{job.due || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Installer Assigned:</strong></td>
                                        <td>{job.dates.installerAssigned || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Production Complete:</strong></td>
                                        <td>{job.dates.productionComplete || "N/A"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div >
                        <div className="grid-item">
                            <table>
                                <thead>
                                    <tr>
                                        <th colSpan="2"><h2>Customer Details</h2></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Name:</strong></td>
                                        <td>{customer.name || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Company Name:</strong></td>
                                        <td>{customer.companyName || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>ID:</strong></td>
                                        <td>{customer.ID || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Email:</strong></td>
                                        <td>{customer.email || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Phone:</strong></td>
                                        <td>{customer.phone || "N/A"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                       
                        {installer && (
                            <div className="grid-item">
                                <table>
                                    <thead>
                                        <tr>
                                            <th colSpan="2">
                                                <h2>Vehicle Details</h2>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><strong>Make:</strong></td>
                                            <td>{vehicle.Make || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Model:</strong></td>
                                            <td>{vehicle.Model || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>License Plate:</strong></td>
                                            <td>{vehicle.LicencePlate || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Vehicle Type:</strong></td>
                                            <td>{vehicle.VehicleType || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Skill Type:</strong></td>
                                            <td>{vehicle.SkillType || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Priority Type:</strong></td>
                                            <td>{vehicle.PriorityType || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Estimated Hours:</strong></td>
                                            <td>{vehicle.EstimatedHours || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Installer ID:</strong></td>
                                            <td>{vehicle.installerID || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Tenant ID:</strong></td>
                                            <td>{vehicle.tenantID || "N/A"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            )}
                        
                        
                        {installer && (
                            <div className="grid-item">
                                <table>
                                    <thead>
                                        <tr>
                                            <th colSpan="2">
                                                <h2>Installer Details</h2>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><strong>Name:</strong></td>
                                            <td>{installer.name || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>ID:</strong></td>
                                            <td>{installer.accountID || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Email:</strong></td>
                                            <td>{installer.email || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Phone:</strong></td>
                                            <td>{installer.phone || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Skill Set:</strong></td>
                                            <td>{installer.skillSet || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Hours:</strong></td>
                                            <td>{installer.hours || "N/A"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                        
                    </div>
                </div>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <p>You are trying to view a job while signed out. Please sign in to continue.</p>
            </UnauthenticatedTemplate>
        </div>
    );
}
